import React, { useState, useEffect, useCallback } from "react";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import LotForm from "../../../../../commonComponents/LotForm";
import getEventItemDetail from "../../../../../../api/adminAPI/getEventItemDetails";
import getEventDetail from "../../../../../../api/getEventDetail";
import useStyles from "../../../../Create/Event/Items/item.style";
import updateEventItem from "../../../../../../api/adminAPI/updateEventItem";
import Loader from "../../../../../../common/Loader";
import "react-toastify/dist/ReactToastify.css";

function EditItem({ eventEditId, eventItemId, SetHide }) {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [eventDetails, setEventDetails] = useState({});
  const [initialData, setInitialData] = useState({});
  const [eventItemInfo, setEventItemInfo] = useState({
    lotNumber: "",
    shortDescription: "",
    longDescription: "",
    quantity: "",
    unit: "",
    startPrice: "",
    startDateAndTime: "",
    increment: "",
    endDateAndTime: "",
    remarks: "",
    eventItemImages: [],
    currency: "",
    timeInterval: null,
    maxMissedBids: null,
    minimumAmount: "",
  });
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [options, setOptions] = useState([]);
  const [loadingData, setLoadingData] = useState(true);

  const fetchInitialData = useCallback(async () => {
    try {
      setLoadingData(true);
      const [eventRes, itemRes] = await Promise.all([
        getEventDetail({ auctionId: eventEditId }),
        getEventItemDetail(eventEditId, eventItemId)
      ]);

      if (eventRes.data) {
        setEventDetails(eventRes.data);
      }

      if (itemRes.data) {
        const data = itemRes.data;
        setInitialData(data);
        setEventItemInfo({
          lotNumber: data.lotNumber || "",
          shortDescription: data.shortDescription || "",
          longDescription: data.longDescription || "",
          quantity: data.quantity || "",
          unit: data.unit || "",
          startPrice: data.startPrice || "",
          startDateAndTime: data.startDateAndTime || "",
          increment: data.increment || "",
          endDateAndTime: data.endDateAndTime || "",
          timeInterval: data.timeInterval || null,
          maxMissedBids: data.maxMissedBids || null,
          remarks: data.remarks || "",
          eventItemImages: [], // New uploads only
          currency: data.currency || "",
          minimumAmount: data.minimumAmount || "",
        });
        setSelectedCurrency(data.currency || null);
      }
    } catch (error) {
      console.error("Error fetching lot details:", error);
      toast.error("Failed to load lot details");
    } finally {
      setLoadingData(false);
    }
  }, [eventEditId, eventItemId]);

  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  const handleSubmit = async (payload) => {
    try {
      setIsLoading(true);
      
      // Merge with existing data if fields are empty (to match original logic)
      const finalPayload = { ...payload };
      if (!finalPayload.lotNumber) finalPayload.lotNumber = initialData.lotNumber;
      if (!finalPayload.shortDescription) finalPayload.shortDescription = initialData.shortDescription;
      if (!finalPayload.longDescription) finalPayload.longDescription = initialData.longDescription;
      if (!finalPayload.unit) finalPayload.unit = initialData.unit;
      
      const { data } = await updateEventItem(finalPayload, eventEditId, eventItemId);
      if (data) {
        toast.success("Event Item Updated Successfully!");
        setTimeout(() => {
          setIsLoading(false);
          SetHide(false);
        }, 1500);
      }
    } catch (error) {
      console.error("Error updating event item:", error);
      setIsLoading(false);
      if (error.response) {
        toast.error(error.response.data.error || "Something went wrong!");
      } else {
        toast.error("Network Error!");
      }
    }
  };

  if (loadingData) {
    return <Loader isLoading={true} />;
  }

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <div className="editRules">
        <LotForm
          mode="edit"
          eventItemInfo={eventItemInfo}
          setEventItemInfo={setEventItemInfo}
          eventDetails={eventDetails}
          selectedCurrency={selectedCurrency}
          setSelectedCurrency={setSelectedCurrency}
          options={options}
          setOptions={setOptions}
          setIsLoading={setIsLoading}
          onSubmit={handleSubmit}
          classes={classes}
          onCancel={() => SetHide(false)}
          initialData={initialData}
        >
          <div className={classes.saveNextBtn}>
            <Button
              className={classes.pre}
              onClick={() => SetHide(false)}
            >
              Cancel
            </Button>
            <Button
              className={classes.next}
              type="submit"
              sx={{ marginLeft: "1em" }}
            >
              Update
            </Button>
          </div>
        </LotForm>
      </div>
    </>
  );
}

export default EditItem;
